import moment from "moment";
import QueryString from "qs";
import { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getEventParticipant } from "../../../api/events.api";
import useAxios from "../../../hooks/useAxios";
import useInterval from "../../../hooks/useInterval";
import useNotification from "../../../hooks/useNotification";
import Ripples from 'react-ripples';
import Loader from "../../Loader";
import ErrorResponse from "../../ErrorResponse";
import { IEventParticipant, IGetEventParticipant } from "../../../models/events.model";
import { AttendanceContents } from "../../../pages/event/attendance";
import { useTranslation } from "react-i18next";

interface IProps {
  setParticipant: (participant: IEventParticipant) => void;
  setContent: (content: AttendanceContents) => void;
}

const PhoneInput: FC<IProps> = ({
  setContent,
  setParticipant,
}) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const eventNo = Number(query.eventNo);
  const { infoNotification } = useNotification();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios<IGetEventParticipant>();

  const [time, setTime] = useState(moment().format(i18n.language === 'ko' ? 'A h시 m분' : 'A h:m'));
  const [mobilePhone, setMobilePhone] = useState('');

  useEffect(() => {
    if (submitRes?.data && !submitIsLoading) {
      setMobilePhone('');
      setParticipant(submitRes.data);
      setContent(AttendanceContents.Result);
    }
  }, [submitRes, submitIsLoading]);

  useEffect(() => {
    if (submitError) {
      setMobilePhone('');
    }
  }, [submitError]);

  useInterval(() => {
    setTime(moment().format(i18n.language === 'ko' ? 'A h시 m분' : 'A h:m'));
  }, 1000);

  const onAddNumber = (n: number) => {
    setMobilePhone(mobilePhone + n);
  }

  const onDeleteNumber = () => {
    setMobilePhone(mobilePhone.slice(0, -1));
  }

  const onSubmit = () => {
    if (!mobilePhone) {
      return infoNotification(t('event.attendance.1'));
    }

    submitExecute(getEventParticipant(eventNo, { mobilePhone }));
  }

  return (
    <>
      {submitIsLoading && <Loader />}
      <ErrorResponse error={submitError} />

      <div className="phonebox left-box mr-5">
        <div className="date">{moment().format('YYYY-MM-DD')}</div>
        <div className="time">{time}</div>
        <div className="input">
          <input
            type="number"
            className="form-control"
            value={mobilePhone}
            onFocus={e => e.target.blur()}
          />
        </div>
      </div>
      <div className="phonebox right-box ml-5">
        <div className="dials">
          {[...Array(9)].map((el, index) => {
            return (
              <Ripples>
                <div
                  className="dial"
                  onClick={() => onAddNumber(index + 1)}
                >
                  {index + 1}
                </div>
              </Ripples>
            )
          })}
          <Ripples>
            <div
              className="dial"
              onClick={() => onDeleteNumber()}
            >
              ←
            </div>
          </Ripples>
          <Ripples>
            <div
              className="dial"
              onClick={() => onAddNumber(0)}
            >
              0
            </div>
          </Ripples>
          <Ripples>
            <div
              className="dial confirm"
              onClick={onSubmit}
            >
              {t('common.button.confirm')}
            </div>
          </Ripples>
        </div>
      </div>
    </>
  );
}

export default PhoneInput;
